import { API_DEVICE_ORDERS } from "../../constants/apis";
import { COMPONENT, DEVICE_ORDERS } from "../../constants/constants";
import { TSet } from "../common/useSet";
import { showConfetti } from "../../components/elements/ConfettiView";
import { reloadData } from "../../components/lists/ListHandler";
import { FundSourceCard, CalculatorCard } from "../../components/elements/CardElements";
import { InfoBox } from "../../components/elements/Elements";
import { INFO_YELLOW } from "../../constants/colors";
import { currencyFormat } from "../../utils/helpers";
import { useWallet } from "../wallets/useWallet";
import { transactionPinField } from "../../utils/pinUtils";

export const usePayDepositForm = ({ state }: any) => {
  const order = state || {};
  const { id: orderId, device, deposit_amount, total_financed_amount, monthly_installment, selected_plan_months } = order;
  const { getWalletBalance } = useWallet();

  const fields = [
    {
      type: COMPONENT,
      component: (
        <CalculatorCard
          title="Deposit Summary"
          fields={{
            device: device?.name,
            plan: `${selected_plan_months} months`,
            deposit_amount: currencyFormat(deposit_amount),
            financed_after_deposit: currencyFormat(total_financed_amount),
            monthly_installment: currencyFormat(monthly_installment),
          }}
        />
      ),
    },
    transactionPinField,
    {
      type: COMPONENT,
      component: <FundSourceCard />,
    },
    {
      type: COMPONENT,
      component: (
        <InfoBox color={INFO_YELLOW}>
          <b>{currencyFormat(deposit_amount)}</b> will be deducted from your wallet
          immediately. This action cannot be reversed.
        </InfoBox>
      ),
    },
  ];

  const onSubmit = ({ payload }: any = {}): TSet => {
    return {
      api: `${API_DEVICE_ORDERS}${orderId}/pay-deposit/`,
      params: { pin: payload?.pin },
      method: "POST",
      successMessage: { message: "Deposit paid successfully!", duration: 5 },
      onSuccess: () => {
        reloadData(DEVICE_ORDERS);
        showConfetti();
        getWalletBalance();
      },
    };
  };

  return {
    fields,
    onSubmit,
    title: "Pay Device Deposit",
    submitText: `Pay ${currencyFormat(deposit_amount)}`,
  };
};